const COLORS = [
  { name: "Negro", value: "#000000" },
  { name: "Blanco", value: "#FFFFFF" },
  { name: "Rojo", value: "#FF0000" },
  { name: "Azul", value: "#0000FF" },
  { name: "Verde", value: "#008000" },
  { name: "Amarillo", value: "#FFFF00" },
  { name: "Naranja", value: "#FFA500" },
];

export const ColorPalette = ({ editor }) => {
  if (!editor) return null;

  const currentColor = editor.getAttributes("textStyle")?.color || "";

  return (
    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
      {COLORS.map((c) => (
        <button
          key={c.value}
          title={c.name}
          onClick={() =>
            editor.chain().focus().setColor(c.value).run()
          }
          style={{
            width: "22px",
            height: "22px",
            borderRadius: "50%",
            backgroundColor: c.value,
            border:
              currentColor === c.value
                ? "3px solid #555"          // destaca el color activo
                : "1px solid #ccc",
            cursor: "pointer",
          }}
        />
      ))}
      {/* Opción de reset a color default */}
      <button
        onClick={() => editor.chain().focus().unsetColor().run()}
        style={{
          marginLeft: "8px",
          padding: "2px 6px",
          fontSize: "12px",
          cursor: "pointer",
        }}
      >
        Reset
      </button>
    </div>
  );
};
